export enum Permission {
  /* Dashboard */
  StatisticsGet = "statistics.get",

  /* Users section */
  UsersCreate = "users.create",
  UserAgentOnlyCreate = "user-agent-role-only.create",
  UsersGet = "users.get",
  UsersUpdate = "users.update",
  UsersDelete = "users.delete",

  /* Roles section */
  PermissionsGet = "permissions.get",
  RolesGet = "roles.get",
  RolesCreate = "roles.create",
  RolesUpdate = "roles.update",
  RolesDelete = "roles.delete",

  /* Transactions section */
  TransactionsCreate = "transactions.create",
  TransactionsGet = "transactions.get",

  /* Customers section */
  CustomerBase = "customer.base",
  CustomersGet = "customers.get",
  CustomersActivate = "customers.activate",
  BalanceGet = "balance.get",

  /* Delivery areas section */
  LocationsUpdate = "locations.update",
  LocationsGet = "locations.get",
  LocationsMenuGet = "locations-menu.get",

  /* Settings section */
  ExchangeRateUpdate = "exchange-rate.update",
  BalanceExpirationUpdate = "balance-expiration.update",
  BalanceExpirationAgentLimitUpdate = "extend-balance-expiration-agent-limit.update",
  BalanceExpirationManagerLimitUpdate = "extend-balance-expiration-manager-limit.update",
  RefundAddAgentLimitUpdate = "refund-add-limit-agent.update",
  RefundAddManagerLimitUpdate = "refund-add-limit-manager.update",
  SettingsGet = "settings.get",
  SettingsUpdate = "settings.update",

  /* other */
  EmployeesGet = "employees.get",
  EmployeesCreate = "employees.create",
  InvitationsCreate = "invitations.create",
  InvitationsGet = "invitations.get",
  OrdersGet = "orders.get",
  PackagesCreate = "packages.create",
  PackagesUpdate = "packages.update",
  DeliveriesAllOptions = "deliveries.all-options",
}

export const initialPermissions = {
  // Role
  isUserAgent: false,
  isUserManager: false,
  /* Dashboard */
  canStatisticsGet: false,

  /* Users section */
  canUsersCreate: false,
  canUserAgentOnlyCreate: false,
  canUsersGet: false,
  canUsersUpdate: false,
  canUsersDelete: false,

  /* Roles section */
  canPermissionsGet: false,
  canRolesGet: false,
  canRolesCreate: false,
  canRolesUpdate: false,
  canRolesDelete: false,

  /* Transactions section */
  canTransactionsCreate: false,
  canTransactionsGet: false,

  /* Customers section */
  canCustomerBase: false,
  canCustomersGet: false,
  canCustomersActivate: false,
  canBalanceGet: false,

  /* Delivery areas section */
  canLocationsUpdate: false,
  canLocationsGet: false,
  canLocationsMenuGet: false,

  /* Settings section */
  canExchangeRateUpdate: false,
  canBalanceExpirationUpdate: false,
  canSettingsGet: false,
  canSettingsUpdate: false,
  isBalanceExpirationAgentLimitUpdate: false,
  isBalanceExpirationManagerLimitUpdate: false,
  isRefundAddAgentLimitUpdate: false,
  isAddManagerLimitUpdate: false,

  /* other */
  canEmployeesGet: false,
  canEmployeesCreate: false,
  canInvitationsCreate: false,
  canInvitationsGet: false,
  canOrdersGet: false,
  canPackagesCreate: false,
  canPackagesUpdate: false,
  canDeliveriesAllOptions: false,
};

export const permissionLabel: Record<Permission, string> = {
  [Permission.BalanceExpirationUpdate]: "Edit Expiration balance",
  [Permission.BalanceGet]: "Check Expiration balance",
  [Permission.CustomerBase]: "Check Base customer information",
  [Permission.CustomersActivate]: "Activate Customers",
  [Permission.CustomersGet]: "Check Customers",
  [Permission.DeliveriesAllOptions]: "Create Deliveries",
  [Permission.EmployeesCreate]: "Create Employees",
  [Permission.EmployeesGet]: "Check Employees",
  [Permission.ExchangeRateUpdate]: "Edit Exchange rate",
  [Permission.BalanceExpirationAgentLimitUpdate]:
    "Limit extend expiration days (Agent role)",
  [Permission.BalanceExpirationManagerLimitUpdate]:
    "Limit extend expiration days (Manager role)",
  [Permission.InvitationsCreate]: "Create Invitations",
  [Permission.InvitationsGet]: "Check Invitations",
  [Permission.LocationsMenuGet]: "Check Zones menu",
  [Permission.LocationsGet]: "Check Zones",
  [Permission.LocationsUpdate]: "Edit Zones",
  [Permission.OrdersGet]: "Check Orders",
  [Permission.PackagesCreate]: "Create Coin Packages",
  [Permission.PackagesUpdate]: "Edit Coin Packages",
  [Permission.PermissionsGet]: "Check Permissions",
  [Permission.RefundAddAgentLimitUpdate]:
    "Limit Adding/Refunding FMCoins (Agent role)",
  [Permission.RefundAddManagerLimitUpdate]:
    "Limit Adding/Refunding FMCoins (Manager role)",
  [Permission.RolesCreate]: "Create Roles",
  [Permission.RolesDelete]: "Delete Roles",
  [Permission.RolesGet]: "Check Roles",
  [Permission.RolesUpdate]: "Edit Roles",
  [Permission.SettingsGet]: "Check Settings",
  [Permission.SettingsUpdate]: "Edit Settings",
  [Permission.StatisticsGet]: "Check Statistics",
  [Permission.TransactionsCreate]: "Create Transactions",
  [Permission.TransactionsGet]: "Check Transactions",
  [Permission.UserAgentOnlyCreate]: "Create only Agent users",
  [Permission.UsersCreate]: "Create Users",
  [Permission.UsersDelete]: "Delete Users",
  [Permission.UsersGet]: "Check Users",
  [Permission.UsersUpdate]: "Edit Users",
};
